import React from "react";
import { IconProps } from "../index";
import { colors } from "src/assets";

const Index: React.FC<IconProps> = ({ color, size }) => {
  const localWidth = size * (19 / 24);
  const localHeight = size * (19 / 24);
  const localColor = color || colors.white;
  return (
    <svg width={localWidth} height={localHeight} viewBox="0 0 19 19">
      <path
        d="M0,9.5A9.5,9.5,0,1,1,9.5,19,9.511,9.511,0,0,1,0,9.5Zm1.461,0a8.033,8.033,0,0,0,13.147,6.2L3.3,4.393A7.994,7.994,0,0,0,1.461,9.5Zm14.186,5.174A8.034,8.034,0,0,0,4.326,3.354Z"
        fill={localColor}
      />
    </svg>
  );
};

export default Index;
